module.exports = __webpack_public_path__ + "img/tech_md.2e963bb.webp";